// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'GET',
    endpoint: '/api/distinte?societaId={societaId}&commessaId={commessaId}',
    requestBody: null,
    response: '{"success":true,"data":[{"id":"number","commessaId":"number","ordineId":"number","numero":"number","tipo":"MERCE|LAVORAZIONI","addebito":"NOSTRO|CLIENTE","descrizione":"string|null","stato":"BOZZA|CONFERMATA","confermataAt":"string|null","createdAt":"string","ordine":{"id":"number","numero":"string","stato":"string","flussoCommerciale":"string","societaId":"number"},"confermataDa":{"id":"number","nome":"string","cognome":"string|null"},"_count":{"righe":"number"}}]}'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
